import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import type { JSX } from 'react';
import { useFormContext } from 'react-hook-form';

import { AutocompleteAsyncFormField } from '~components/FormFields/AutocompleteAsyncFormField';
import { User } from '~hooks/useUsers/models';
import useUsers from '~hooks/useUsers/useUsers';

import type { ProjectFormSchemaInterface } from '../../projectFormSchema';
import { useProjectFormV2Context } from '../ProjectFormV2Context';

// Mirrors the legacy form. Render-only by design: the
// watched-company subscription lives in ProjectFormV2Provider (added for
// this panel, reused for the cascading reset), so the panel
// reads `watchedSelectedCompany` via context instead of subscribing itself.
// The `useUsers().getCompanyUsersTypeahead` callback is the legacy data
// source; v2 keeps the same surface so the BE contract is unchanged. The
// autocomplete is `isRequired={false}` and `clearable={true}` (verbatim
// from legacy).
export function RequesterPanel(): JSX.Element {
  const { control, formState } = useFormContext<ProjectFormSchemaInterface>();
  const { watchedSelectedCompany } = useProjectFormV2Context();
  const { getCompanyUsersTypeahead } = useUsers();

  return (
    <Card sx={{ p: 2, my: 2 }}>
      <Typography variant="form-section-title" sx={{ mb: 1 }}>
        {t('project.form.requester')}
      </Typography>
      <AutocompleteAsyncFormField
        control={control}
        errors={formState.errors}
        name="requester"
        isRequired={false}
        clearable={true}
        getValue={(user: User) => user.id}
        getLabel={(user: User) => user.fullName ?? ''}
        asyncCallback={getCompanyUsersTypeahead}
        extraRequestOptions={{ companyId: watchedSelectedCompany?.id }}
        hideLabel
      />
    </Card>
  );
}
